import React from "react";

const IstarPrivacy = () => {
  return (
    <div
      style={{
        padding: "2rem",
        lineHeight: "1.6",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <h1>Privacy Policy</h1>
      <p>Last updated: July 1, 2025</p>
      <p>
        Welcome to iStar. This Privacy Policy explains how Atticus Labs, LLC
        ("we", "us", "our") collects, uses, and discloses your information when
        you use our application. By accessing or using iStar, you agree to the
        collection, use, and disclosure of your information in accordance with
        this Privacy Policy.
      </p>
      <h2>Information We Collect</h2>
      <p>
        We may collect personal data that you provide directly to us, such as
        your name, email address, and any other details necessary to deliver our
        service.
      </p>
      <h2>How We Use Your Information</h2>
      <p>The information we collect is used to:</p>
      <ul>
        <li>Provide and maintain our service</li>
        <li>Communicate with you about your account or our services</li>
        <li>Improve and customize our service</li>
        <li>Ensure security and compliance</li>
      </ul>
      <h2>Disclosure of Your Information</h2>
      <p>
        We do not sell your personal data. We may share information with
        third-party vendors and partners who assist in operating our service,
        provided they agree to maintain the confidentiality and security of your
        information.
      </p>
      <h2>Your Rights</h2>
      <p>
        You have the right to access, update, or request deletion of your
        personal information. If you need assistance or have any questions,
        please contact us at the email provided below.
      </p>
      <h2>Changes to This Policy</h2>
      <p>
        We may modify this Privacy Policy from time to time. We will notify you
        of any updates by posting the new policy on this page and updating the
        "Last updated" date.
      </p>
      <h2>Contact Us</h2>
      <p>
        If you have any questions about this Privacy Policy or our practices,
        please contact us at tom@atticuslabs.net.
      </p>
    </div>
  );
};

export default IstarPrivacy;
